/**
 * Maps backend order/payment status values to `account.*` translation keys.
 * Unknown statuses fall back to the raw backend value so new statuses never
 * render as a missing-key warning.
 */
const STATUS_KEYS: Record<string, string> = {
  pending: "account.statusPending",
  processing: "account.statusProcessing",
  confirmed: "account.statusConfirmed",
  completed: "account.statusCompleted",
  cancelled: "account.statusCancelled",
  shipped: "account.statusShipped",
  delivered: "account.statusDelivered",
  paid: "account.statusPaid",
  failed: "account.statusFailed",
  refunded: "account.statusRefunded",
  on_hold: "account.statusOnHold",
};

type Translate = (
  key: string,
  replacements?: Record<string, string | number>
) => string;

/** Translate a backend status value; unknown statuses return the raw value. */
export function translateOrderStatus(t: Translate, status?: string): string {
  if (!status) return "";
  const key = STATUS_KEYS[status.toLowerCase()];
  return key ? t(key) : status;
}
